module.exports = __webpack_public_path__ + "static/media/importICS1.03a7b219.png";